import React from 'react';
import { Link } from 'react-router-dom';
import { PLACES } from '../../data/smaken';
import { Note, ArrowMark, StarMark } from '../Marks';
import { PlaceCard } from '../PlaceCard';
import { Reveal } from '../Reveal';
const featured = PLACES.find(p => p.slug === 'lilla-verket')!;
const supporting = PLACES.filter(p => ['kalmar-kafferosteri', 'kafferosteriet-kalmar', 'gronsakslandet', 'glasbrukets-matsal'].includes(p.slug)).slice(0, 3);
export function Discovered() {
  return <section aria-labelledby="upptackt-rubrik" className="border-t border-black/12" data-id="element-378" data-mp="1kclrmz2ux0ie">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-379" data-mp="1ybv53qzohgio">
        <Reveal data-id="element-380" data-mp="1y9r69ngmz7p9">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-381" data-mp="1y9ipvllb1k9b">
            <div data-id="element-382" data-mp="1ub1hkyq5e3qb">
              <h2 id="upptackt-rubrik" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-383" data-mp="1u8ffhem10gfh">
                Upptäckt på Småken
              </h2>
              <div className="mt-3 flex items-center gap-2" data-id="element-384" data-mp="3w2odneowcotn">
                <StarMark className="h-5 w-5 text-rod" data-id="element-385" data-mp="1xsggkr3q1m1s" />
                <Note data-id="element-386" data-mp="1xu1fesx2jr5g">Vi hittade något du borde veta om.</Note>
              </div>
            </div>
            <Link to="/upptack" className="group flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide2 text-black transition-colors duration-150 ease-out hover:text-rod" data-id="element-387" data-mp="22s2ul2rdj6bn">
              Se allt
              <ArrowMark className="h-4 w-9 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-388" data-mp="2hgpjnw6szcg2" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-10 lg:grid-cols-[minmax(0,1.25fr),minmax(0,1fr)] lg:gap-14" data-id="element-389" data-mp="2lk436wtyaay9">
          {/* The feature reads as an editorial recommendation, not a listing. */}
          <Reveal data-id="element-390" data-mp="2vffknmwqtw9p">
            <Link to={`/plats/${featured.slug}`} className="group block" data-id="element-391" data-mp="2vduq3xafidbu">
              <div className="relative aspect-[4/3] overflow-hidden bg-black/5" data-id="element-392" data-mp="w4nybtn27be6">
                <img src={featured.image} alt={featured.name} className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-393" data-mp="112z5fwlyz7sp" />
              </div>
              <p className="mt-6 text-[11px] font-semibold uppercase tracking-wide2 text-rod" data-id="element-394" data-mp="12zedo4m3b7m2">
                {featured.city} · {featured.tags.join(' · ')}
              </p>
              <h3 className="display-xl mt-2 text-4xl uppercase sm:text-5xl" data-id="element-395" data-mp="y2xor872gp7x">{featured.name}</h3>
              <p className="mt-4 max-w-xl text-lg leading-relaxed text-black/75" data-id="element-396" data-mp="1bxzpzi0yxqee">{featured.blurb}</p>
              <p className="mt-3 max-w-xl leading-relaxed text-black/60" data-id="element-397" data-mp="17wy03rsxyqp3">{featured.description[0]}</p>
              <span className="mt-6 inline-flex items-center gap-2 border-b-2 border-black pb-1 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out group-hover:border-rod group-hover:text-rod" data-id="element-398" data-mp="1ls01q2qr9tw3">
                Upptäck
                <ArrowMark className="h-3.5 w-8" data-id="element-399" data-mp="1qqjqeawqhjs5" />
              </span>
            </Link>
          </Reveal>

          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-1" data-id="element-400" data-mp="2acd4xk0lcows">
            {supporting.map((place, i) => <Reveal key={place.slug} delay={0.06 * (i + 1)} data-id="element-401" data-mp="2ebud4l7ek05n" data-mpi={i}>
                <PlaceCard place={place} ratio="wide" data-id="element-402" data-mp="20bt2wf58zgdi" />
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}